/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ code: NonNullable<unknown> }} Partner_Admin_Commission_Attributed_ViaInputs */



/**
* | output |
* | --- |
* | "via code {code}" |
*
* @param {Partner_Admin_Commission_Attributed_ViaInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_attributed_via = /** @type {((inputs: Partner_Admin_Commission_Attributed_ViaInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Attributed_ViaInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`über Code ${i?.code}`)
	return /** @type {LocalizedString} */ (`via code ${i?.code}`)
});